import React from 'react';

function DbPrivacy() {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy for Daily Briefing</h1>
      <section>
        <h2>1. Introduction</h2>
        <p>
          Welcome to Daily Briefing. This Privacy Policy explains how we collect, use, and disclose information about you when you use our augmented reality application (the “Application”) and connect it to your Google Account.
        </p>
        <p>Your privacy is important to us, and we are committed to protecting it.</p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>
          To provide our service, we require access to your Google Calendar data. When you grant permission using the .../auth/calendar.readonly scope, our Application has the ability to access the following information on a read-only basis:
        </p>
                  <p>Calendar Information: A list of your calendars, including their names and IDs.</p>
          <p>Event Information: For events within your calendars, we can access all associated data.</p>

      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <p>
          We use the information we collect for the sole purpose of operating the Application. This includes:
        </p>
          <p>Displaying Your Events: To show you your upcoming events within the AR interface on your glasses.</p>
          <p>
            Generating Event Summaries: To provide a convenient, at-a-glance summary of your schedule, we send the event summary (title) and event time to a third-party Generative AI service. This service processes the information and returns a summary, which is then displayed to you.
          </p>
    
      </section>

      <section>
        <h2>4. Information Sharing and Disclosure</h2>
        <p>
          We do not sell or rent your personal information. We only share your information in the limited circumstances described below:
        </p>
        <ul>
          <li>
            <strong>With Third-Party Service Providers:</strong> We share a limited subset of your information with the following service provider to enable a core feature of our Application:
              <p>
                OpenAI: We send the event summary and time to this service to generate a concise summary for you. The information is used solely for this purpose. We do not share any other personal information with this provider.
              </p>
          </li>
          <li>
            <strong>For Legal Reasons:</strong> We may disclose your information if required to do so by law or in the good faith belief that such action is necessary to comply with a legal obligation.
          </li>
        </ul>
      </section>

      <section>
        <h2>5. Data Security</h2>
        <p>
          We take reasonable measures to protect the information we handle. However, no electronic transmission or storage is 100% secure. The access token that allows us to view your calendar data is stored securely on your device.
        </p>
      </section>

      <section>
        <h2>6. Data Retention</h2>
        <p>
          We access your calendar data in real-time to provide our service. Information processed by the Generative AI service is not stored or logged by us. We do not keep a copy of your calendar events but we do keep the calendar IDs in local storage on device, which get deleted when signed out.
        </p>
      </section>

      <section>
        <h2>7. Your Rights and Choices</h2>
        <p>
          You can revoke our Application's access to your Google Account at any time by visiting the Google Account security settings page. If you revoke access, we will no longer be able to access your calendar data.
        </p>
      </section>

      <section>
        <h2>8. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on our website.
        </p>
      </section>

      <section>
        <h2>9. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy, please contact me at: andrewdouglas004@gmail.com
        </p>

      </section>
    </div>
  );
}

export default DbPrivacy;